import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link } from "react-router"

import WizardCard from "../../components/WizardCard"
import CaptionList from "../../components/CaptionList"
import { LAND_GOALS } from "../../shared/constants"
import { ACTION_ICON } from "./constants"
import { useAccountUrlPrefix } from "../../hooks"
import { GovtApWizardType } from "@/types/govtAppWizard"
import { ProjectListTypes } from "@/types/program"

export interface GovtWizardSummaryStacksCardProps {
  projectList: ProjectListTypes | undefined
  govtAppWizard: GovtApWizardType | undefined
}

const GovtWizardSummaryStacksCard = ({
  projectList,
  govtAppWizard,
}: GovtWizardSummaryStacksCardProps) => {
  const accountUrlPrefix = useAccountUrlPrefix()

  let stackCount = 1

  return (
    <WizardCard paddingSize="md-y">
      <CaptionList
        caption="You chose practice stacks related to:"
        list={govtAppWizard?.action_groups?.map(
          (actionGroup) => LAND_GOALS[actionGroup.goal]
        )}
        captionClass="!text-base !font-body !leading-[130%] !tracking-[0.32px]"
        itemClass="!text-charcoal-500 !text-base !font-body !leading-[130%] !tracking-[0.32px] mt-3"
      />

      <div>
        {govtAppWizard?.action_groups?.map(
          (actionGroup) =>
            actionGroup?.action_data
              ?.filter((action) =>
                govtAppWizard.selected_action_keys.includes(action.action_key)
              )
              .map((action) => (
                <div key={action.action_key} className="mt-9">
                  <p className="text-gray-500 text-sm font-mono font-medium leading-[150%] tracking-[1.68px] uppercase">
                    Stack #{stackCount++}
                  </p>

                  <div className="mt-3">
                    <FontAwesomeIcon
                      icon={
                        ACTION_ICON[action.header as keyof typeof ACTION_ICON]
                      }
                      style={{ fontSize: 32 }}
                      color="#2D8052"
                    />
                  </div>

                  <h3>{action.header}</h3>

                  <p className="text-base leading-[140%] tracking-[0.32px]">
                    <strong>Goal:</strong> {LAND_GOALS[action.goal]}
                  </p>

                  <p className="text-base leading-[140%] tracking-[0.32px]">
                    <strong>Summary: </strong> {action.text}
                  </p>

                  <CaptionList
                    caption="Practices included in stack:"
                    list={action.project_ids.map((projectId) => {
                      const projectData = projectList?.project_data.find(
                        (project) => project.id === projectId
                      )

                      if (!projectData) {
                        return null
                      }

                      return (
                        <span key={projectData.id}>
                          <Link
                            key={projectId}
                            to={`${accountUrlPrefix}/programs/${projectData.id}`}
                            className="link"
                          >
                            {projectData?.name}
                          </Link>{" "}
                          {projectData.description_short}
                        </span>
                      )
                    })}
                    captionClass="!text-base !font-normal !leading-[140%] !tracking-[0.32px] !mt-3"
                    itemClass="!text-base !leading-[140%] !tracking-[0.32px] !mt-3"
                  />
                </div>
              ))
        )}
      </div>

      <div className="mt-16">
        <h3 className="text-xl font-display font-semibold leading-[140%] tracking-[0.4px]">
          Eligibility Quiz Answers
        </h3>

        <ul className="list-decimal list-outside text-charcoal-500 text-sm leading-[140%] tracking-[0.28px] pl-5 mt-4">
          {govtAppWizard?.account_attestations?.map(
            ({ attestation_id, attestation, value }) => (
              <li key={attestation_id}>
                <div>{attestation}</div>
                <div>a. {value}</div>
              </li>
            )
          )}
        </ul>
      </div>
    </WizardCard>
  )
}

export default GovtWizardSummaryStacksCard
